import {
  BankIcon,
  CartIcon,
  FileIcon,
  IconButton,
  InvoiceIcon,
  PlusIcon,
  Typography,
} from "@codat/orchard-ui";
import { SourceType } from "model";

import Button from "components/Button";

import styles from "./SourceTypeSummary.module.css";

const sourceTypeMap: Record<
  SourceType,
  {
    icon: React.FC;
    label: string;
  }
> = {
  Accounting: {
    icon: () => <InvoiceIcon />,
    label: "Accounting",
  },
  Banking: {
    icon: () => <BankIcon />,
    label: "Banking",
  },
  Commerce: {
    icon: () => <CartIcon />,
    label: "Commerce",
  },
  Other: {
    icon: () => <FileIcon />,
    label: "Business documents",
  },
};

interface SourceTypeSummaryProps {
  sourceType: SourceType;
  connectedCount: number;
  disconnectedCount?: number;
  uploadedFilesCount?: number;
  onAddAnother?: () => void;
}

export const SourceTypeSummary: React.FC<SourceTypeSummaryProps> = ({
  sourceType,
  connectedCount,
  disconnectedCount,
  uploadedFilesCount,
  onAddAnother,
}) => {
  return (
    <div className={styles.sourceTypeSummary} data-testid="source-type-summary">
      <div className={styles.innerWrapper}>
        <div className={styles.icon}>{sourceTypeMap[sourceType].icon({})}</div>
        <div
          className={styles.sourceTypeName}
          data-testid="source-type-summary-source-type-name"
        >
          {sourceTypeMap[sourceType].label}
        </div>
        <div className={styles.connectionCountSummary}>
          {!!connectedCount && (
            <Typography
              className={styles.connectionCount}
              variant="small"
              as="p"
              data-testid="source-type-summary-connected-count"
            >
              {connectedCount} connected
            </Typography>
          )}
          {!!uploadedFilesCount && (
            <Typography
              className={styles.connectionCount}
              variant="small"
              as="p"
              data-testid="source-type-summary-uploaded-files-count"
            >
              {uploadedFilesCount} uploaded files
            </Typography>
          )}
          {!!disconnectedCount && (
            <Typography
              className={styles.connectionCount}
              variant="small"
              as="p"
              data-testid="source-type-summary-disconnected-count"
            >
              {disconnectedCount} disconnected
            </Typography>
          )}
        </div>
        {onAddAnother && (
          <div className={styles.addAnotherWrapper}>
            <Button
              className={styles.addAnotherBtn}
              variant="secondary"
              size="small"
              label="Add more"
              analyticsName="Add more"
              onClick={onAddAnother}
              eventProperties={{
                sourceType,
              }}
            />
            <IconButton
              className={styles.addAnotherBtnMobile}
              label="Add more"
              onClick={onAddAnother}
            >
              <PlusIcon />
            </IconButton>
          </div>
        )}
      </div>
    </div>
  );
};
